import { io } from "socket.io-client";

const USER_SOCKET_URL ="https://artim.shop";

const userSocket = io(USER_SOCKET_URL, {
  path: "/backendtest_9/user-socket.io",

  withCredentials: true,

  autoConnect: false,

  transports: ["polling"],

  upgrade: false,
});

export default userSocket;